// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dcc-block-wrapper .dcc-table tbody tr:hover {\n  background-color: transparent !important;\n}\n.dcc-block-wrapper .no-data {\n  padding: 20px;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
